import styled from 'styled-components'
import { ReactComponent as Eth } from 'assets/svg/ethereum.svg'

export const Title = styled.h1`
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 1rem;
`

export const HelpButton = styled.button`
  appearance: none;
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.text1};
  border-radius: ${({ theme }) => theme.BORDER_RADIUS.smallest};
  color: ${({ theme }) => theme.text1};
  cursor: pointer;
  font-weight: normal;
  margin-top: 1.5rem;
  padding: 0.5rem 2.5rem;
  transition: ${({ theme }) => theme.TRANSITION.medium};

  &:hover {
    background-color: #fff;
    color: ${({ theme }) => theme.text5};
  }

  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding: 0.5rem 1.5rem;
    margin-top: 0;
  `}
`

export const ClaimButton = styled.button`
  appearance: none;
  background-color: #fff;
  border: none;
  border-radius: ${({ theme }) => theme.BORDER_RADIUS.smallest};
  color: ${({ theme }) => theme.primaryText1};
  cursor: pointer;
  font-weight: 500;
  padding: 0.6rem 1.8rem;
  transition: ${({ theme }) => theme.TRANSITION.fast};

  &:hover {
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
  }
`

export const Image = styled.img`
  border-radius: 100%;
`

export const Banner = styled.div`
  background-image: ${({ theme }) => theme.gradient1};
  border-radius: ${({ theme }) => theme.BORDER_RADIUS.small};
  color: white;
  padding: 1rem 1.5rem;
  width: 100%;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    padding: 1rem;
  `};
`

export const BannerTitle = styled.h1`
  font-size: 1.5rem;
  font-weight: 700;
`

export const BannerText = styled.p`
  margin: 1rem 0;
`

export const BannerFlex = styled.div`
  display: flex;
  justify-content: space-between;
  row-gap: 2rem;

  @media only screen and (max-width: 900px) {
    flex-direction: column;
  }
`

export const BannerFlexWrapper = styled.div`
  @media only screen and (max-width: 900px) {
    width: 100%;
  }
`

export const SubBanner = styled.div`
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: ${({ theme }) => theme.BORDER_RADIUS.small};
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: space-between;
  padding: 1.5rem;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
    margin-top: 0;
    padding: 1rem;
  `};
`

export const SubBannerFlex = styled.div`
  align-items: center;
  display: flex;
  gap: 4rem;
  justify-content: space-between;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    gap: 0;
  `}
`

export const SubBannerText = styled.div`
  font-weight: 500;
  white-space: nowrap;
`

export const PoolFilter = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 0.5rem;
  padding: 1rem 0px;

  ${({ theme }) => theme.mediaWidth.upToLarge`
  `}
`

export const InputSearch = styled.input`
  appearance: none;
  background-color: ${({ theme }) => theme.bg3};
  border: 1px solid transparent;
  border-radius: ${({ theme }) => theme.BORDER_RADIUS.small};
  color: ${({ theme }) => theme.text2};
  outline: none;
  padding: 0.5rem 0.8rem;
  transition: border 0.2s;

  &:hover {
    border-color: ${({ theme }) => theme.purple1};
  }

  &:focus {
    border-color: ${({ theme }) => theme.purple1};
  }

  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: none;
  `}
`

export const PoolFilterRight = styled.div`
  align-items: center;
  column-gap: 0.5rem;
  display: flex;
  justify-content: space-between;
`

export const MobileFilterWrapper = styled.div`
  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: none;
  `}
`
export const PoolFilterButton = styled.button<{ active?: boolean }>`
  appearance: none;
  background-color: inherit;
  border: none;
  color: ${({ theme, active }) => (active ? theme.purple1 : theme.text3)};
  cursor: pointer;
  font-size: 1.5rem;
  font-weight: 500;
  outline: none;
  transition: 0.2s;

  &:hover {
    opacity: 0.6;
  }
`

export const MobileCheckBoxWrapper = styled.div`
  align-items: center;
  display: flex;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: none;
  `}
`
export const EthIcon = styled(Eth)`
  height: auto;
  width: 12px;
`

export const NftLogo = styled.img`
  border-radius: 10rem;
  display: flex;
  height: 30px;
  object-fit: cover;
  width: 30px;
`
